import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import gen_sett_icon from "../../../images/settings_icons/gen_sett.ico";
import raw_mat_category_icon from "../../../images/settings_icons/raw_material_category.ico";
import raw_mat_sub_category_icon from "../../../images/settings_icons/raw_material_sub_category.ico";
import vendor_category_icon from "../../../images/settings_icons/vendor_category.ico";
import vendor_buss_type_icon from "../../../images/settings_icons/business_type.ico";
import vehicle_category_icon from "../../../images/settings_icons/vehicle_category.ico";
import department from "../../../images/settings_icons/department.ico";
import shift_time from "../../../images/settings_icons/shift_time.ico";
import complaint_type from "../../../images/settings_icons/complaint_type.ico";
import lead_type_icon from "../../../images/settings_icons/lead_types.ico";
import lead_source_icon from "../../../images/settings_icons/lead_source.ico";
import lead_sts_icon from "../../../images/settings_icons/potential_type.ico";
import service_type_icon from "../../../images/settings_icons/service_type.ico";
import document_type_icon from "../../../images/settings_icons/document_type.ico";
import payment_mode from "../../../images/settings_icons/payment_mode.ico";
import job_role from "../../../images/settings_icons/job_role.ico";
import ledger from "../../../images/settings_icons/ledger.ico";
import sub_ledger from "../../../images/settings_icons/sub_ledger.ico";
import Unit_testing from "../../../images/settings_icons/unit_cat.ico";
import drop_reason from "../../../images/settings_icons/drop_reason.ico";
import holiday from '../../../images/settings_icons/holiday_icon.ico';
import banner from '../../../images/settings_icons/banner_img.ico';
import duration from "../../../images/settings_icons/duration.ico";
import temperature from "../../../images/settings_icons/temperature.ico";
import preparation_category from "../../../images/settings_icons/preparation_category.ico";
import language from '../../../images/settings_icons/language_icon.ico';
import helpdesk from '../../../images/settings_icons/help_desk.png';
import reason from '../../../images/settings_icons/reason.png';
import goalset from '../../../images/settings_icons/goalset.png';
import meals_point from '../../../images/settings_icons/meals_point.png';
import dead_reason from '../../../images/settings_icons/dead_reason.png';
import spam_reason from '../../../images/settings_icons/spam_reason.png';
import service from "../../../images/settings_icons/service.ico";
import leavetypeimg from '../../../images/settings_icons/leave_type.ico';
import menu from '../../../images/settings_icons/menu_img.ico'
import sub_department from '../../../images/settings_icons/sub_department.png';
import hr_level from '../../../images/settings_icons/hr_level.png';
import cookware_category from '../../../images/settings_icons/cookware_category.ico';
import cookware_material from '../../../images/settings_icons/cookware_material.ico';
import cookware_sub_category from '../../../images/settings_icons/cookware_sub_category.ico';
import cookware from '../../../images/settings_icons/cookware.ico';
import machinery_category from '../../../images/settings_icons/machinery_category.png';

import axios from 'axios';

const Settings = () => {
    const [isVisible, setIsVisible] = useState({
        setts: true,
        lead: false,
        subscription: false,
        package: false,
        common: false,
        menus: false,
        purchase: false,
        vehicle: false,
        hr_management: false,
        complaints: false,
        payment: false,
        production: false,
        accounts: false,
        menu: false,
        catering: false,
    });

    const toggleDiv = (section) => {
        setIsVisible((prev) => {
            // Create a new state where all sections are closed, except the clicked one
            const newState = Object.keys(prev).reduce((acc, key) => {
                // If the clicked section is already open, we close it, else open it
                acc[key] = key === section ? !prev[key] : false;
                return acc;
            }, {});

            return newState;
        });
    };

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const [leadtypecount, setleadtypecount] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/leadtype/count`)
            .then(response => {
                setleadtypecount(response.data.count);
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
            });

    }, []);

    const [leadsourcecount, setleadsourcecount] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/leadsource/count`)
            .then(response => {
                setleadsourcecount(response.data.count);
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
            });

    }, []);

    const [leadstatuscount, setleadstatuscount] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/leadstatus/count`)
            .then(response => {
                setleadstatuscount(response.data.count);
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
            });

    }, []);

    const [followupreason, setfollowupreasoncount] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/followupreason/getcount`)
            .then(response => {
                setfollowupreasoncount(response.data.count);
            })
            .catch(error => {
                console.error('There was an error fetching the posts!', error);
            });

    }, []);

    const [spamreason, setspamreason] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/spamreason/getcount`)
            .then(response => {
                setspamreason(response.data.count);
            })
            .catch(error => {
                console.error('There was an error fetching the posts!', error);
            });

    }, []);

    const [deadreason, setdeadreason] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/deadreason/getcount`)
            .then(response => {
                setdeadreason(response.data.count);
            })
            .catch(error => {
                console.error('There was an error fetching the posts!', error);
            });

    }, []);

    const [dropreason, setdropreasoncount] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/dropreason/getcount`)
            .then(response => {
                setdropreasoncount(response.data.count);
            })
            .catch(error => {
                console.error('There was an error fetching the posts!', error);
            });

    }, []);

    const [paymodecount, setPaycount] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/paymentmode/getcount`)
            .then(response => {
                setPaycount(response.data.count);
            })
            .catch(error => {
                console.error('There was an error fetching the posts!', error);
            });

    }, []);

    const [rawmatcount, setRawmatcount] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/rawmaterialcategory/getcount`)
            .then(response => {
                setRawmatcount(response.data.count);
            })
            .catch(error => {
                console.error('There was an error fetching the posts!', error);
            });

    }, []);

    const [unitscount, setUnitscount] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/units/getcount`)
            .then(response => {
                setUnitscount(response.data.count);
            })
            .catch(error => {
                console.error('There was an error fetching the posts!', error);
            });

    }, []);

    const [vendorcatcount, setvendorcat] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/vendorcategory/getcount`)
            .then(response => {
                setvendorcat(response.data.count);
            })
            .catch(error => {
                console.error('There was an error fetching the posts!', error);
            });

    }, []);

    const [businesstypcount, setbusicount] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/businesstype/getcount`)
            .then(response => {
                setbusicount(response.data.count);
            })
            .catch(error => {
                console.error('There was an error fetching the posts!', error);
            });

    }, []);

    const [vehicategory, setvehcategory] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/vehiclecategory/getcount`)
            .then(response => {
                setvehcategory(response.data.count);
            })
            .catch(error => {
                console.error('There was an error fetching the posts!', error);
            });

    }, []);

    const [servicecount, setservicecount] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/servicetype/getcount`)
            .then(response => {
                setservicecount(response.data.count);
            })
            .catch(error => {
                console.error('There was an error fetching the posts!', error);
            });

    }, []);

    const [doctypcount, setdoctyp] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/documenttype/getcount`)
            .then(response => {
                setdoctyp(response.data.count);
            })
            .catch(error => {
                console.error('There was an error fetching the posts!', error);
            });

    }, []);

    const [complainttypecount, setcomplainttypecount] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/complainttype/count`)
            .then(response => {
                setcomplainttypecount(response.data.count);
            })
            .catch(error => {
                console.error('There was an error fetching the posts!', error);
            });

    }, []);

    const [ledgercount, setledgercount] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/ledger/getcount`)
            .then(response => {
                setledgercount(response.data.count);
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
            });

    }, []);

    const [subledgercount, setsubledgercount] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/subledger/getcount`)
            .then(response => {
                setsubledgercount(response.data.count);
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
            });

    }, []);

    const [preparationcount, setpreparationcount] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/preparation-category`)
            .then(response => {
                if (response.data && response.data.PreparationCategoryCount !== undefined) {
                    setpreparationcount(response.data.PreparationCategoryCount);
                } else {
                    console.warn('PreparationCategoryCount not found in response:', response.data);
                }
            })
            .catch(error => {
                console.error('There was an error fetching the posts!', error);
            });
    }, []);

    const [durationcount, setdurationcount] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/duration`)
            .then(response => {
                // console.log('API Response:', response.data);
                setdurationcount(response.data.duration_count);
            })
            .catch(error => {
                console.error('There was an error fetching the posts!', error);
            });

    }, []);

    const [propertytypecount, setpropertytypecount] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/propertytype`)
            .then(response => {
                // console.log('API Response:', response.data);
                setpropertytypecount(response.data.count);
            })
            .catch(error => {
                console.error('There was an error fetching the posts!', error);
            });

    }, []);

    const [propertycount, setpropertycount] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/property`)
            .then(response => {
                // console.log('API Response:', response.data);
                setpropertycount(response.data.property_count);
            })
            .catch(error => {
                console.error('There was an error fetching the posts!', error);
            });

    }, []);

    const [qualitycount, setqualitycount] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/manage-priorities`)
            .then(response => {
                // console.log('API Response:', response.data);
                setqualitycount(response.data.PriorityCount);
            })
            .catch(error => {
                console.error('There was an error fetching the posts!', error);
            });

    }, []);

    const [itemstaggingcount, setitemstaggingcount] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/itemstagging`)
            .then(response => {
                setitemstaggingcount(response.data.data.length);
            })
            .catch(error => {
                console.error('There was an error fetching the posts!', error);
            });

    }, []);

    const [temperatureCount, setTemperatureCount] = useState(0);
    useEffect(() => {
        fetch(`${baseURL}/manage-temperature`)
            .then(response => response.json())
            .then(data => {
                if (data && data.temperature_count !== undefined) {
                    setTemperatureCount(data.temperature_count);
                }
            })
            .catch(error => {
                console.error('Error fetching temperature:', error);
            });
    }, []);

    const [unitcategorycount, setunitcategorycount] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/unitcategory`)
            .then(response => {
                // console.log('API Response:', response.data);
                setunitcategorycount(response.data.count);
            })
            .catch(error => {
                console.error('There was an error fetching the posts!', error);
            });

    }, []);

    const [scorecount, setScorecount] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/score/getcount`)
            .then(response => {
                setScorecount(response.data.count);
            })
            .catch(error => {
                console.error('There was an error fetching the posts!', error);
            });

    }, []);

    const [departmentCount, setDepartmentCount] = useState(0);
    useEffect(() => {
        fetch(`${baseURL}/department`)
            .then(response => response.json())
            .then(data => {
                if (data && data.count !== undefined) {
                    setDepartmentCount(data.count);
                }
            })
            .catch(error => {
                console.error('Error fetching departments:', error);
            });
    }, []);

    const [shiftTimeCount, setshiftTimeCount] = useState(0);
    useEffect(() => {
        fetch(`${baseURL}/shifttime`)
            .then(response => response.json())
            .then(data => {
                if (data && data.count !== undefined) {
                    setshiftTimeCount(data.count);
                }
            })
            .catch(error => {
                console.error('Error fetching departments:', error);
            });
    }, []);

    const [jobRoleCount, setjobRoleCount] = useState(0);
    useEffect(() => {
        fetch(`${baseURL}/jobrole`)
            .then(response => response.json())
            .then(data => {
                if (data && data.count !== undefined) {
                    setjobRoleCount(data.count);
                }
            })
            .catch(error => {
                console.error('Error fetching departments:', error);
            });
    }, []);

    const [leavetype, setleavetype] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/manage-leavetype`)
            .then(response => {
                // console.log("API data:", response.data);
                setleavetype(response.data.LeaveTypeCount);
            })
            .catch(error => {
                console.error('There was an error fetching the posts!', error);
            });

    }, []);

    const [addonservice, setaddonservice] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/addonservice/list`)
            .then(response => {
                setaddonservice(response.data.length);
            })
            .catch(error => {
                console.error('There was an error fetching the posts!', error);
            });

    }, []);

    const [functiontype, setfunctiontype] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/functiontype/list`)
            .then(response => {
                setfunctiontype(response.data.length);
            })
            .catch(error => {
                console.error('There was an error fetching the posts!', error);
            });

    }, []);

    const [cateringtype, setcateringtype] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/cateringtype/list`)
            .then(response => {
                setcateringtype(response.data.length);
            })
            .catch(error => {
                console.error('There was an error fetching the posts!', error);
            });

    }, []);

    const [margincapital, setmargincapital] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/margincapital/list`)
            .then(response => {
                setmargincapital(response.data.length);
            })
            .catch(error => {
                console.error('There was an error fetching the posts!', error);
            });

    }, []);

    const [subdept, setSubDept] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/sub_department/getcount`)
            .then(response => {
                setSubDept(response.data.count);
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
            });

    }, []);

    const [level, setLevel] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/level/getcount`)
            .then(response => {
                setLevel(response.data.count);
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
            });

    }, []);

    const [cookware_catego, setcookcato] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/cookware_category/getcount`)
            .then(response => {
                setcookcato(response.data.count);
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
            });

    }, []);

    const [cook_mate, setcookMate] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/cookware_material/getcount`)
            .then(response => {
                setcookMate(response.data.count);
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
            });

    }, []);

    const [cook_subCato, setcookSubcato] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/cookware_sub_category/getcount`)
            .then(response => {
                setcookSubcato(response.data.count);
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
            });

    }, []);

    const [cookwares, setcookwares] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/cookwares/getcount`)
            .then(response => {
                setcookwares(response.data.count);
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
            });

    }, []);

    const [mechcatego, setmechcatego] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/machinery_category/getcount`)
            .then(response => {
                setmechcatego(response.data.count);
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
            });

    }, []);

    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#025d3a' }}>Settings</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                    </ol>
                </div>
            </div>

            <div className={`sett_hov mb-2 ${isVisible.setts ? 'sett_active' : ''}`}>
                <div className={`cursor-pointer d-flex align-items-center justify-content-between hed_bg px-3 pt-2 ${isVisible.setts ? 'hed_active_bg' : ''}`} onClick={() => toggleDiv('setts')}>
                    <div className='fs-5 font-w500 text-black mb-3'>Settings</div>
                    <div className="cursor-pointer style-1">
                        <span><i className={`fa-solid fa-angles-down text-dark fs-5 icon_clr_hov ${isVisible.setts ? 'icon_clr' : ''}`}></i></span>
                    </div>
                </div>
                {isVisible.setts && (
                    <div className='row px-2 pt-3 pb-1'>
                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={gen_sett_icon} className='w-45px h-45px' alt="General Settings" />
                                            </div>
                                            <div className="mb-0 text-black fs-7">General Settings</div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/general-settings"} target="_blank"><i className="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={holiday} className='w-45px h-45px' alt="Holiday" />
                                            </div>
                                            <div className="mb-0 text-black fs-7">Holiday</div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/holiday"} target="_blank"><i class="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={banner} className='w-45px h-45px' alt="General Settings" />
                                            </div>
                                            <div className="mb-0 text-black fs-7">Banner</div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/banner"} target="_blank"><i class="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={language} className='w-45px h-45px' alt="General Settings" />
                                            </div>
                                            <div className="mb-0 text-black fs-7">Language</div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/language"} target="_blank"><i class="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={helpdesk} className='w-45px h-45px' alt="General Settings" />
                                            </div>
                                            <div className="mb-0 text-black fs-7">Help Desk</div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/help-desk"} target="_blank"><i class="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={goalset} className='w-45px h-45px' alt="General Settings" />
                                            </div>
                                            <div className="mb-0 text-black fs-7">Default Goalset</div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/goalset"} target="_blank"><i class="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}

                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={meals_point} className='w-45px h-45px' alt="General Settings" />
                                            </div>
                                            <div className="mb-0 text-black fs-7">Meals Point</div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/meals-point"} target="_blank"><i class="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                )}
            </div>

            <div className={`sett_hov mb-2 ${isVisible.lead ? 'sett_active' : ''}`}>
                <div className={`cursor-pointer d-flex align-items-center justify-content-between hed_bg px-3 pt-2 ${isVisible.lead ? 'hed_active_bg' : ''}`} onClick={() => toggleDiv('lead')}>
                    <div className='fs-5 font-w500 text-black mb-3'>Lead Management</div>
                    <div className="cursor-pointer style-1">
                        <span><i className={`fa-solid fa-angles-down text-dark fs-5 icon_clr_hov ${isVisible.lead ? 'icon_clr' : ''}`}></i></span>
                    </div>
                </div>
                {isVisible.lead && (
                    <div className='row px-2 pt-3 pb-1'>
                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={lead_type_icon} className='w-45px h-45px' alt="lead type" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Lead Type</div>
                                                <span className="fs-8 font-w500">{leadtypecount} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/lead-type"} target="_blank"><i className="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={lead_source_icon} className='w-45px h-45px' alt="State" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Lead Source</div>
                                                <span className="fs-8 font-w500">{leadsourcecount} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/lead-source"} target="_blank"><i className="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={lead_sts_icon} className='w-45px h-45px' alt="City" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Lead Status</div>
                                                <span className="fs-8 font-w500">{leadstatuscount} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/lead-status"} target="_blank"><i className="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={reason} className='w-45px h-45px' alt="City" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Followup Reason</div>
                                                <span className="fs-8 font-w500">{followupreason} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/followup-reason"} target="_blank"><i className="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={spam_reason} className='w-45px h-45px' alt="City" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Spam Reason</div>
                                                <span className="fs-8 font-w500">{spamreason} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/spam-reason"} target="_blank"><i className="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={dead_reason} className='w-45px h-45px' alt="City" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Dead Reason</div>
                                                <span className="fs-8 font-w500">{deadreason} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/dead-reason"} target="_blank"><i className="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={reason} className='w-45px h-45px' alt="City" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Internal Call Reason</div>
                                                <span className="fs-8 font-w500">{internalcall} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/internal-call"} target="_blank"><i className="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}

                    </div>
                )}
            </div>

            <div className={`sett_hov mb-2 ${isVisible.subscription ? 'sett_active' : ''}`}>
                <div className={`cursor-pointer d-flex align-items-center justify-content-between hed_bg px-3 pt-2 ${isVisible.subscription ? 'hed_active_bg' : ''}`} onClick={() => toggleDiv('subscription')}>
                    <div className='fs-5 font-w500 text-black mb-3'>Subscription Management</div>
                    <div className="cursor-pointer style-1">
                        <span><i className={`fa-solid fa-angles-down text-dark fs-5 icon_clr_hov ${isVisible.subscription ? 'icon_clr' : ''}`}></i></span>
                    </div>
                </div>
                {isVisible.subscription && (
                    <div className='row px-2 pt-3 pb-1'>
                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={drop_reason} className='w-45px h-45px' alt="drop reason" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Drop Reason</div>
                                                <span className="fs-8 font-w500">{dropreason} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/drop-reason"} target="_blank"><i className="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <div className={`sett_hov mb-2 ${isVisible.production ? 'sett_active' : ''}`}>
                <div className={`cursor-pointer d-flex align-items-center justify-content-between hed_bg px-3 pt-2 ${isVisible.production ? 'hed_active_bg' : ''}`} onClick={() => toggleDiv('production')}>
                    <div className='fs-5 font-w500 text-black mb-3'>Production Management</div>
                    <div className="cursor-pointer style-1">
                        <span><i class={`fa-solid fa-angles-down text-dark fs-5 icon_clr_hov ${isVisible.production ? 'icon_clr' : ''}`}></i></span>
                    </div>
                </div>
                {isVisible.production && (
                    <div className='row px-2 pt-3 pb-1'>
                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={preparation_category} className='w-45px h-45px' alt="drop reason" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Preparation Type</div>
                                                <span className="fs-8 font-w500">{preparationcount} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/preparation-category"} target="_blank"><i class="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={duration} className='w-45px h-45px' alt="drop reason" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Duration</div>
                                                <span className="fs-8 font-w500">{durationcount} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/duration"} target="_blank"><i class="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={temperature} className='w-45px h-45px' alt="drop reason" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Temperature</div>
                                                <span className="fs-8 font-w500">{temperatureCount} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/temperature"} target="_blank"><i class="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={temperature} className='w-45px h-45px' alt="drop reason" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Property Type</div>
                                                <span className="fs-8 font-w500">{propertytypecount} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/item-property-type"} target="_blank"><i class="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={temperature} className='w-45px h-45px' alt="drop reason" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Property</div>
                                                <span className="fs-8 font-w500">{propertycount} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/item-property"} target="_blank"><i class="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={temperature} className='w-45px h-45px' alt="drop reason" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Quality Checklist Priority</div>
                                                <span className="fs-8 font-w500">{qualitycount} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/quality-checklist-priority"} target="_blank"><i class="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={temperature} className='w-45px h-45px' alt="drop reason" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Margin Capital</div>
                                                <span className="fs-8 font-w500">{margincapital} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/margin-capital"} target="_blank"><i class="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={temperature} className='w-45px h-45px' alt="drop reason" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Item Staging Process</div>
                                                <span className="fs-8 font-w500">{itemstaggingcount} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/item-staging-process"} target="_blank"><i class="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* cookware category */}
                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={cookware_category} className='w-45px h-45px' alt="Cookware Category" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Cookware Category</div>
                                                <span className="fs-8 font-w500">{cookware_catego} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/cookware_category"} target="_blank"><i class="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* cookware material */}
                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={cookware_material} className='w-45px h-45px' alt="Cookware Material" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Cookware Material</div>
                                                <span className="fs-8 font-w500">{cook_mate} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/cookware_material"} target="_blank"><i class="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* cookware subcategory */}
                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={cookware_sub_category} className='w-45px h-45px' alt="Cookware Subcategory" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Cookware Subcategory</div>
                                                <span className="fs-8 font-w500">{cook_subCato} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/cookware_subcategory"} target="_blank"><i class="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* cookware */}
                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={cookware} className='w-45px h-45px' alt="Cookwares" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Cookwares</div>
                                                <span className="fs-8 font-w500">{cookwares} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/cookware"} target="_blank"><i class="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                )}
            </div>

            <div className={`sett_hov mb-2 ${isVisible.payment ? 'sett_active' : ''}`}>
                <div className={`cursor-pointer d-flex align-items-center justify-content-between hed_bg px-3 pt-2 ${isVisible.payment ? 'hed_active_bg' : ''}`} onClick={() => toggleDiv('payment')}>
                    <div className='fs-5 font-w500 text-black mb-3'>Payment Management</div>
                    <div className="cursor-pointer style-1">
                        <span><i className={`fa-solid fa-angles-down text-dark fs-5 icon_clr_hov ${isVisible.payment ? 'icon_clr' : ''}`}></i></span>
                    </div>
                </div>
                {isVisible.payment && (
                    <div className='row px-2 pt-3 pb-1'>
                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={payment_mode} className='w-45px h-45px' alt="Payment Mode" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Payment Mode</div>
                                                <span className="fs-8 font-w500">{paymodecount} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/payment-mode"} target="_blank"><i className="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <div className={`sett_hov mb-2 ${isVisible.purchase ? 'sett_active' : ''}`}>
                <div className={`cursor-pointer d-flex align-items-center justify-content-between hed_bg px-3 pt-2 ${isVisible.purchase ? 'hed_active_bg' : ''}`} onClick={() => toggleDiv('purchase')}>
                    <div className='fs-5 font-w500 text-black mb-3'>Purchase Management</div>
                    <div className="cursor-pointer style-1">
                        <span><i class={`fa-solid fa-angles-down text-dark fs-5 icon_clr_hov ${isVisible.purchase ? 'icon_clr' : ''}`}></i></span>
                    </div>
                </div>
                {isVisible.purchase && (
                    <div className='row px-2 pt-3 pb-1'>
                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={raw_mat_category_icon} className='w-45px h-45px' alt="Category" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Raw Material Category</div>
                                                <span className="fs-8 font-w500">{rawmatcount} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/raw-material-category"} target="_blank"><i class="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                {/* <img src={raw_mat_sub_category_icon} className='w-45px h-45px' alt="Unit Category" /> */}
                                                <img src={Unit_testing} className='w-45px h-45px' alt="Unit testing" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Unit Category</div>
                                                <span className="fs-8 font-w500">{unitcategorycount} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/unit-category"} target="_blank"><i class="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={raw_mat_sub_category_icon} className='w-45px h-45px' alt="Units" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Units</div>
                                                <span className="fs-8 font-w500">{unitscount} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/units"} target="_blank"><i class="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={vendor_category_icon} className='w-45px h-45px' alt="Vendor Category" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Vendor Category</div>
                                                <span className="fs-8 font-w500">{vendorcatcount} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/vendor-category"} target="_blank"><i class="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={vendor_sub_category_icon} className='w-45px h-45px' alt="Vendor Sub Category" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Vendor Sub Category</div>
                                                <span className="fs-8 font-w500">03 Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/vendor-sub-category"}><i class="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={raw_mat_sub_category_icon} className='w-45px h-45px' alt="Units" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Score</div>
                                                <span className="fs-8 font-w500">{scorecount} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/score"} target="_blank"><i className="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-3">
                                                <img src={vendor_buss_type_icon} className='w-45px h-45px' alt="Business Type" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Business Type</div>
                                                <span className="fs-8 font-w500">{businesstypcount} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/business-type"} target="_blank"><i class="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <div className={`sett_hov mb-2 ${isVisible.catering ? 'sett_active' : ''}`}>
                <div className={`cursor-pointer d-flex align-items-center justify-content-between hed_bg px-3 pt-2 ${isVisible.catering ? 'hed_active_bg' : ''}`} onClick={() => toggleDiv('catering')}>
                    <div className='fs-5 font-w500 text-black mb-3'>Catering Management</div>
                    <div className="cursor-pointer style-1">
                        <span><i class={`fa-solid fa-angles-down text-dark fs-5 icon_clr_hov ${isVisible.catering ? 'icon_clr' : ''}`}></i></span>
                    </div>
                </div>
                {isVisible.catering && (
                    <div className='row px-2 pt-3 pb-1'>
                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={service} className='w-45px h-45px' alt="Category" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Add on Service</div>
                                                <span className="fs-8 font-w500">{addonservice} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/add-on-service"} target="_blank"><i class="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={service} className='w-45px h-45px' alt="Category" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Function Type</div>
                                                <span className="fs-8 font-w500">{functiontype} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/function-type"} target="_blank"><i class="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={service} className='w-45px h-45px' alt="Category" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Catering Type</div>
                                                <span className="fs-8 font-w500">{cateringtype} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/catering-type"} target="_blank"><i class="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <div className={`sett_hov mb-2 ${isVisible.vehicle ? 'sett_active' : ''}`}>
                <div className={`cursor-pointer d-flex align-items-center justify-content-between hed_bg px-3 pt-2 ${isVisible.vehicle ? 'hed_active_bg' : ''}`} onClick={() => toggleDiv('vehicle')}>
                    <div className='fs-5 font-w500 text-black mb-3'>Maintenance Management</div>
                    <div className="cursor-pointer style-1">
                        <span><i className={`fa-solid fa-angles-down text-dark fs-5 icon_clr_hov ${isVisible.vehicle ? 'icon_clr' : ''}`}></i></span>
                    </div>
                </div>
                {isVisible.vehicle && (
                    <div className='row px-2 pt-3 pb-1'>
                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={vehicle_category_icon} className='w-45px h-45px' alt="Category" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Vehicle Category</div>
                                                <span className="fs-8 font-w500">{vehicategory} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/vehicle-category"} target="_blank"><i className="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={service_type_icon} className='w-45px h-45px' alt="Category" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Service Type</div>
                                                <span className="fs-8 font-w500">{servicecount} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/service-type"} target="_blank"><i className="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={document_type_icon} className='w-45px h-45px' alt="Category" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Document Type</div>
                                                <span className="fs-8 font-w500">{doctypcount} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/document-type"} target="_blank"><i className="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={machinery_category} className='w-45px h-45px' alt="Category" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Machinery Category</div>
                                                <span className="fs-8 font-w500">{mechcatego} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/mechinery-category"} target="_blank"><i className="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <div className={`sett_hov mb-2 ${isVisible.hr_management ? 'sett_active' : ''}`}>
                <div className={`cursor-pointer d-flex align-items-center justify-content-between hed_bg px-3 pt-2 ${isVisible.hr_management ? 'hed_active_bg' : ''}`} onClick={() => toggleDiv('hr_management')}>
                    <div className='fs-5 font-w500 text-black mb-3'>HR Management</div>
                    <div className="cursor-pointer style-1">
                        <span><i class={`fa-solid fa-angles-down text-dark fs-5 icon_clr_hov ${isVisible.hr_management ? 'icon_clr' : ''}`}></i></span>
                    </div>
                </div>
                {isVisible.hr_management && (
                    <div className='row px-2 pt-3 pb-1'>
                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={department} className='w-45px h-45px' alt="Department" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Department</div>
                                                <span className="fs-8 font-w500">{departmentCount.toString().padStart(2, '0')} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/department"} target="_blank"><i class="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Sub department */}
                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={sub_department} className='w-45px h-45px' alt="Department" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Sub Department</div>
                                                <span className="fs-8 font-w500">{subdept} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/subdepartment"} target="_blank"><i className="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* level */}
                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={hr_level} className='w-45px h-45px' alt="Department" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Level</div>
                                                <span className="fs-8 font-w500">{level} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/level"} target="_blank"><i className="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={job_role} className='w-45px h-45px' alt="Job Role" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Job Role</div>
                                                <span className="fs-8 font-w500">{jobRoleCount.toString().padStart(2, '0')} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/job-role"} target="_blank"><i class="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={shift_time} className='w-45px h-45px' alt="Shift Time" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Shift Time</div>
                                                <span className="fs-8 font-w500">{shiftTimeCount.toString().padStart(2, '0')} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/shift-time"} target="_blank"><i class="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={leavetypeimg} className='w-45px h-45px' alt="Job Role" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Leave Type</div>
                                                <span className="fs-8 font-w500">{leavetype} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/leave-type"} target="_blank"><i class="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <div className={`sett_hov mb-2 ${isVisible.complaints ? 'sett_active' : ''}`}>
                <div className={`cursor-pointer d-flex align-items-center justify-content-between hed_bg px-3 pt-2 ${isVisible.complaints ? 'hed_active_bg' : ''}`} onClick={() => toggleDiv('complaints')}>
                    <div className='fs-5 font-w500 text-black mb-3'>Complaint Management</div>
                    <div className="cursor-pointer style-1">
                        <span><i className={`fa-solid fa-angles-down text-dark fs-5 icon_clr_hov ${isVisible.complaints ? 'icon_clr' : ''}`}></i></span>
                    </div>
                </div>
                {isVisible.complaints && (
                    <div className='row px-2 pt-3 pb-1'>
                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={complaint_type} className='w-45px h-45px' alt="Complaint Type" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Complaint Type</div>
                                                <span className="fs-8 font-w500">{complainttypecount} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/complaint-type"} target="_blank"><i className="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <div className={`sett_hov mb-2 ${isVisible.accounts ? 'sett_active' : ''}`}>
                <div className={`cursor-pointer d-flex align-items-center justify-content-between hed_bg px-3 pt-2 ${isVisible.accounts ? 'hed_active_bg' : ''}`} onClick={() => toggleDiv('accounts')}>
                    <div className='fs-5 font-w500 text-black mb-3'>Accounts Management</div>
                    <div className="cursor-pointer style-1">
                        <span><i className={`fa-solid fa-angles-down text-dark fs-5 icon_clr_hov ${isVisible.accounts ? 'icon_clr' : ''}`}></i></span>
                    </div>
                </div>
                {isVisible.accounts && (
                    <div className='row px-2 pt-3 pb-1'>
                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={ledger} className='w-45px h-45px' alt="Complaint Type" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Ledger</div>
                                                <span className="fs-8 font-w500">{ledgercount} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/ledger"} target="_blank"><i className="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3 mb-3'>
                            <div className="card h-auto m-0">
                                <div className="card-body p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="text-center me-2">
                                                <img src={sub_ledger} className='w-45px h-45px' alt="Complaint Type" />
                                            </div>
                                            <div className='mb-0'>
                                                <div className="mb-0 text-black fs-7">Sub Ledger</div>
                                                <span className="fs-8 font-w500">{subledgercount} Records Here</span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="icon-bx style-1">
                                                <Link to={"/sub-ledger"} target="_blank"><i className="fa-solid fa-arrow-right-from-bracket fs-3"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

        </>
    )


}
export default Settings;